import { PageLocaleEnum } from 'common/enums/PageLocaleEnum'
import React from 'react'
import { useTranslation } from 'react-i18next'
import LanguageSwitcherUi from './ui/LanguageSwitcherUi'

export const LanguageSwitcher = () => {
  const { i18n } = useTranslation()

  return (
    <LanguageSwitcherUi>
      <select
        onChange={async e => {
          await i18n.changeLanguage(e.target.value)
        }}
        value={i18n.language}
      >
        {Object.values(PageLocaleEnum).map(locale => (
          <option key={locale} value={locale}>
            {locale}
          </option>
        ))}
      </select>
    </LanguageSwitcherUi>
  )
}
